# Caller's OWNER membership teams for the My teams shortcut.
# memberOf is membership, not ownership. Do not request it.
# Descendants stay on the server (InboxFilter.teamIds).
query inboxOwnedTeams {
  userPerson: getPersonForUser {
    aggregateId
    memberships(input: { membershipTypes: [OWNER] }) {
      groupId
      type
    }
  }
}
